import SwitchRoleProfileModal from "./SwitchRoleProfileModal";

export default SwitchRoleProfileModal;
